var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu_container"},[_c('a',{attrs:{"href":"https://edgeryders.eu","target":"_blank"}},[_c('Logo',{attrs:{"type":_vm.type,"color":_vm.color}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }